export default __webpack_public_path__ + "static/media/icon-sertifikat-ac.6c18e610.png";